import {
  MONTHLY_STATUS,
  DAILY_STATUS,
  HOURLY_STATUS,
  STORE_TOP,
  DEPARTMENT_TOP,
  MENU_TOP,
  DORMATN_RESERVED_CNT
} from 'actions/dashboard';

function dashboard(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${MONTHLY_STATUS}_PENDING`:
      return {
        ...state,
        monthly: payload
      };
    case `${MONTHLY_STATUS}_FULFILLED`:
      return {
        ...state,
        monthly: payload
      };
    case `${MONTHLY_STATUS}_REJECTED`:
      return {
        ...state,
        monthly: payload
      };

    case `${DAILY_STATUS}_PENDING`:
      return {
        ...state,
        daily: payload
      };
    case `${DAILY_STATUS}_FULFILLED`:
      return {
        ...state,
        daily: payload
      };
    case `${DAILY_STATUS}_REJECTED`:
      return {
        ...state,
        daily: payload
      };

    case `${HOURLY_STATUS}_PENDING`:
      return {
        ...state,
        hourly: payload
      };
    case `${HOURLY_STATUS}_FULFILLED`:
      return {
        ...state,
        hourly: payload
      };
    case `${HOURLY_STATUS}_REJECTED`:
      return {
        ...state,
        hourly: payload
      };

    case `${STORE_TOP}_PENDING`:
      return {
        ...state,
        storeTop: payload
      };
    case `${STORE_TOP}_FULFILLED`:
      return {
        ...state,
        storeTop: payload
      };
    case `${STORE_TOP}_REJECTED`:
      return {
        ...state,
        storeTop: payload
      };

    case `${DEPARTMENT_TOP}_PENDING`:
      return {
        ...state,
        departmentTop: payload
      };
    case `${DEPARTMENT_TOP}_FULFILLED`:
      return {
        ...state,
        departmentTop: payload
      };
    case `${DEPARTMENT_TOP}_REJECTED`:
      return {
        ...state,
        departmentTop: payload
      };

    case `${MENU_TOP}_PENDING`:
      return {
        ...state,
        menuTop: payload
      };
    case `${MENU_TOP}_FULFILLED`:
      return {
        ...state,
        menuTop: payload
      };
    case `${MENU_TOP}_REJECTED`:
      return {
        ...state,
        menuTop: payload
      };

    case `${DORMATN_RESERVED_CNT}_PENDING`:
      return {
        ...state,
        dormantRevCnt: payload
      };
    case `${DORMATN_RESERVED_CNT}_FULFILLED`:
      return {
        ...state,
        dormantRevCnt: payload
      };
    case `${DORMATN_RESERVED_CNT}_REJECTED`:
      return {
        ...state,
        dormantRevCnt: payload
      };

    default:
      return state;
  }
}

export default dashboard;
